import branches from "./branches";
import academicYears from "./academicYears";
import statistics from "./statistics";
import groups from "./groups";
import teachers from "./teachers";
import roles from "./roles";
import staffers from "./staffers";
import students from "./students";
import contracts from "./contracts";
import payments from "./payments";
import stafferTasks from "./stafferTasks";
import employeeRegistrations from "./employeeRegistrations";
import telegram from "./telegram";
import telegramParents from "./telegramParents";
import directorMyWeeks from "./directorMyWeeks";
import sciences from "./sciences";
import migration from "./migration";
import telegramSurveys from "./telegramSurveys";
import telegramQuestionnaires from "./telegramQuestionnaires";
import salaries from "./salaries";
import lessonsSchedules from "./lessonsSchedules";
import faceIdDevices from "./faceIdDevices";
import KPIAutomations from "./KPIAutomations";
import telegramApi from "./telegram-api";
import holidays from "./holidays";
import salesDepartment from "./salesDepartment";
import prices from "./prices";
import reports from "./reports";
import murojaatlar from "./murojaatlar";
import camp from "./camp";
import telegramStaffers from "./telegramStaffers";
import examinations from "./examination";
import warehouse from "./warehouse";
import arrivalDepartureTickets from "./arrivalDepartureTickets";
import salaryRanks from "./salaryRanks";
import events from "./events";
import jurist from "./jurist";
import parentsChatsDev from "./parentsChatsDev";
import duties from "./duties";
import tests from "./tests";
import studentsTests from "./students-tests";
import certificates from "./certificates";
import testsSchedule from "./testsSchedule";
import hr from "./hr";
import zakovat from "./zakovat";
import zakovatAttempts from "./zakovat-attempts";
import olympiad from "./olympiad";
import olympiadAttempts from "./olympiad-attempts";
import tmb from "./tmb";
import weeklyEducationalTopics from "./weeklyEducationalTopics";
import activityDays from "./activityDays";
export default {
  namespaced: true,
  state: {
    branchesList: [],
    selectedBranch: { _id: null, name: null },
    canSelectBranch: false,
    academicYearsList: [],
    selectedAcademicYear: { _id: null, year: "" },
    canSelectAcademicYear: false,
    role: null,
    userRoles: [],
  },
  modules: {
    branches,
    academicYears,
    staffers,
    statistics,
    groups,
    teachers,
    roles,
    students,
    contracts,
    payments,
    stafferTasks,
    employeeRegistrations,
    telegram,
    "telegram-api": telegramApi,
    telegramParents,
    directorMyWeeks,
    sciences,
    migration,
    telegramSurveys,
    telegramQuestionnaires,
    salaries,
    lessonsSchedules,
    faceIdDevices,
    KPIAutomations,
    holidays,
    salesDepartment,
    prices,
    reports,
    murojaatlar,
    camp,
    telegramStaffers,
    examinations,
    warehouse,
    arrivalDepartureTickets,
    salaryRanks,
    events,
    jurist,
    parentsChatsDev,
    duties,
    tests,
    "students-tests": studentsTests,
    testsSchedule,
    certificates,
    hr,
    zakovat,
    "zakovat-attempts": zakovatAttempts,
    olympiad,
    "olympiad-attempts": olympiadAttempts,
    tmb,
    weeklyEducationalTopics,
    activityDays,
  },
};
